window.onload = function() {
  var swiperMain = new Swiper(".slider-main", {
    slidesPerView: 1.5,
    spaceBetween: "10%",
    loop: true,
    speed: 1000,
    loopAdditionalSlides: 3,
    loopedSlides: 1,
    grabCursor: false,
      breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 2.5,
    }
  },
    navigation: {
      nextEl: ".service-container .swiper-button-next",
      prevEl: ".service-container .swiper-button-prev"
    }
    });
};

